// extracted by mini-css-extract-plugin
export default {"al_wrapper":"ActivityLogTab_al_wrapper__Eqo14"};